export default {
  SHOW_KEYBOARD: 'keyboard/SHOW_KEYBOARD',
  HIDE_KEYBOARD: 'keyboard/HIDE_KEYBOARD'
};
